import { useState, useEffect } from "react";
import GlobalStyles from "./GlobalStyles";
import { ThemeProvider } from "@emotion/react";
import useWebSocket from "react-use-websocket";
import theme from "./theme";
import ChatPopup from "./components/ChatPopup";
import styled from "@emotion/styled";
import ChatButton from "./components/ChatButton";
import { v4 as uuidv4 } from "uuid";
import CTABubble from "./components/CTABubble";
import useAppStore from "./appStore";

const SOCKET_URL = "wss://mozaicchatbotbackend-kokwttjzkq-uc.a.run.app/chat";
// const SOCKET_URL = "wss://staging-mozaicchatbotbackend-kokwttjzkq-uc.a.run.app/chat";
// const SOCKET_URL = "ws://localhost:8000/chat";
function App() {
  const [messages, setMessages] = useState(() => {
    const savedMessages = sessionStorage.getItem("messages");
    return savedMessages ? JSON.parse(savedMessages) : [{ content: "I'm MO. How can I help you?", type: "ai" }];
    // return [{ content: "I'm MO. How can I help you?", type: "ai" }]
  });
  const [chatId, _] = useState(() => {
    const savedChatId = sessionStorage.getItem("chatId");
    return savedChatId ? savedChatId : uuidv4();
  });
  const setIsAITyping = useAppStore((state) => state.setIsAITyping);

  const [pendingMessage, setPendingMessage] = useState(""); // New state
  const [responseString, setResponseString] = useState("");
  const [responding, setResponding] = useState(false);

  // useEffect(() => {
  //   if (messages.length === 0) {
  //     addMessage("I’m Mozaic’s AI assistant. Is there anything I can help you with?", "ai");
  //   }
  // }, []);

  // const { sendJsonMessage, lastJsonMessage, readyState, lastMessage } =
  const { sendJsonMessage, lastMessage } = useWebSocket(SOCKET_URL, {
    onOpen: () => console.log("opened"),
    shouldReconnect: (closeEvent) => true,
    reconnectAttempts: 10,
    //attemptNumber will be 0 the first time it attempts to reconnect, so this equation results in a reconnect pattern of 1 second, 2 seconds, 4 seconds, 8 seconds, and then caps at 10 seconds until the maximum number of attempts is reached
    reconnectInterval: (attemptNumber) =>
      Math.min(Math.pow(2, attemptNumber) * 1000, 10000),
    onError: (error) => {
      console.log("WebSocket error:", error);
    },
    onClose: (closeEvent) => {
      console.log("WebSocket closed:", closeEvent);
    },
  });

  const handleSendMessage = (inputValue) => {
    console.log("handleSendMessage");
    if (!inputValue) return;

    const updatedMessages = [
      ...messages,
      { content: inputValue, type: "human" },
    ];
    addMessage(inputValue, "human");
    addMessage(" ", "ai");
    setResponseString("");

    sessionStorage.setItem("messages", JSON.stringify(updatedMessages)); // Add this line

    sendJsonMessage({ messages: updatedMessages, chat_id: chatId });
  };

  const addMessage = (content, type) => {
    if (!content) return;
    setMessages((prevMessages) => {
      const updatedMessages = [...prevMessages, { content, type }];
      sessionStorage.setItem("messages", JSON.stringify(updatedMessages)); // Add this line
      return updatedMessages;
    });
    setIsAITyping(type === "ai");
  };

  const addLinkMessage = (content, type, link, metadata) => {
    if (!content) return;
    setMessages((prevMessages) => {
      const updatedMessages = [
        ...prevMessages,
        { content, type, link: link, metadata: metadata },
      ];
      sessionStorage.setItem("messages", JSON.stringify(updatedMessages)); // Add this line
      return updatedMessages;
    });
    setIsAITyping(type === "ai");
  };

  // Update session storage when messages state changes
  useEffect(() => {
    sessionStorage.setItem("messages", JSON.stringify(messages));
  }, [messages]);

  useEffect(() => {
    console.log(lastMessage);
    if (lastMessage) {
      if (pendingMessage === "") {
        addMessage("", "ai");
      }
      try {
        const message = JSON.parse(lastMessage.data);
        if (message.message !== undefined) {
          if (message.type !== undefined) {
            if (message.type === "link") {
              addLinkMessage(
                message.message,
                "ai",
                message.link,
                message.metadata
              );
              setIsAITyping(false);
            }
            else if (message.type === "final_message") {
              console.log("final message recieved", message.message);
              // do this after a timeout
              setTimeout(() => {
                setResponseString(message.message);
              }, 200);
              // setResponseString(message.message);
            }
            else {
             // more cases incoming maybe
            }
          } else {
            setResponseString((str) => `${str}${message.message}`);
          }
        } else {
          if (message.type !== "llm_end") {
            // if (message.type === "link") {
            //   addMessage(" ", "ai");
            // }
            // addMessage(" ", "ai");
            // setResponseString("");
            // setIsAITyping(false);
          }
          console.log("no message message");
        }
      } catch (e) {
        console.log("error", e);
        // setResponseString(str => `${str}${lastMessage.data}`)
        setPendingMessage("");
        setResponseString("");
        setIsAITyping(false);
      }
    }
  }, [lastMessage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // replace the last message with the new one with content responseString
    if (responseString && messages.length > 0) {
      const updatedMessages = [...messages];
      updatedMessages[updatedMessages.length - 1].content = responseString;
      setMessages(updatedMessages);
      setIsAITyping(false);
    }
  }, [responseString]); // eslint-disable-line react-hooks/exhaustive-deps

  
  // Set chatId in session storage whenever it changes
  useEffect(() => {
    sessionStorage.setItem("chatId", chatId);
  }, [chatId]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <StyledApp>
        <ChatPopup messages={messages} sendMessage={handleSendMessage} />
        <ButtonContainer>
          <CTABubble />
          <ChatButton />
        </ButtonContainer>
      </StyledApp>
    </ThemeProvider>
  );
}

const StyledApp = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 10px;
  pointer-events: none;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
`;

export default App;
